package twcomponents

import data.heatmaplayer.ActiveHeatmapLayerDefinitionStore
import data.keywordlayer.ActiveKeywordLayerDefinitionStore
import data.objects.ActiveObjectStore
import dev.fritz2.core.Store
import koin.withKoin
import localization.TL
import localization.getTranslationFlow
import localization.translate
import theme.FormationIcons
import webcomponents.twContentScrollBox
import webcomponents.twoButtonFooter

enum class Delete { Object, KeywordLayer, HeatmapLayer }

fun deleteObjectModal(type: Delete, toggleStore: Store<Boolean>) = twSimpleModalWithCloseHeader(
    "w-96",
    title = TL.CardDeleteConfirmation.CARD_TITLE,
    icon = FormationIcons.DeleteAlt,
    toggleStore = toggleStore,
) { close, _, _ ->
    withKoin {
        val activeObjectStore: ActiveObjectStore = get()
        val activeKeywordLayerDefinitionStore: ActiveKeywordLayerDefinitionStore = get()
        val activeHeatmapLayerDefinitionStore: ActiveHeatmapLayerDefinitionStore = get()

        twContentScrollBox {
            className("gap-4")
            p {
                translate(TL.CardDeleteConfirmation.ARE_YOU_SURE)
            }
            twoButtonFooter(
                primaryTitle = TL.CardSecondaryMenu.DELETE_SHORT.getTranslationFlow(),
                primaryValue = Unit,
                primaryClickHandlers = when (type) {
                    Delete.Object -> listOf(activeObjectStore.delete, close)
                    Delete.KeywordLayer -> listOf(activeKeywordLayerDefinitionStore.deleteKeyWordLayer, close)
                    Delete.HeatmapLayer -> listOf(activeHeatmapLayerDefinitionStore.deleteHeatmapLayer, close)
                },
                primaryStyleType = { danger },
                secondaryTitle = TL.General.KEEP.getTranslationFlow(),
                secondaryClickHandlers = listOf(close),
            )
        }
    }
}
